import { render, staticRenderFns } from "./SupplierInvoiceComponent.vue?vue&type=template&id=1dc14f88&scoped=true"
import script from "./SupplierInvoiceComponent.vue?vue&type=script&lang=js"
export * from "./SupplierInvoiceComponent.vue?vue&type=script&lang=js"
import style0 from "./SupplierInvoiceComponent.vue?vue&type=style&index=0&id=1dc14f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc14f88",
  null
  
)

export default component.exports